module.exports = __webpack_public_path__ + "img/bed.5a04ef37.svg";